import React from "react";

export function MinutesArchive() {
    return (
        <>
        <center> 
			<br/>
            <br/>
            <br/>
            <br/>
            <br/>
	<table width="auto" border="3">
<tbody>
	
<tr>
<td colspan="2" align="center">
	<u><center><strong>2026 Meeting Minutes</strong></center></u>

<tr>
<td valign="top">
	<tr>
</tr>
</td></tr>
<tr>
	<td>

<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2026/FD%231+minutes+January+2026.docx" target="new">January 2026</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2026/FD%231+minutes+February+2026.docx" target="new">February 2026</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/FD%231+minutes+March+2026.docx" target="new">March 2026</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/FD%231+minutes+April+2026.docx" target="new">April 2026</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2026/FD%231+minutes+May+2026.docx" target="new">May 2026</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2026/FD%231+minutes+June2026+(1).docx" target="new">June 2026</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2026/FD%231+minutes+July+2026.docx" target="new">July 2026</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2026/FD%231+minutes+August+2026.docx" target="new">August 2026</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2026/FD%231+minutes+September+2026.docx" target="new">September 2026</a><br/>





	</td>
	</tr>
</td></tr>

	<tr>
<td colspan="2" align="center">
	<u><center><strong>2025 Meeting Minutes</strong></center></u>

<tr>
<td valign="top">
	<tr>
</tr>
</td></tr>
<tr>
	<td>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2024/FD%231minutesJanuary2025.docx" target="new">January 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2025/FD%231+minutes+February+2025.docx" target="new">February 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/FD%231+minutes+March+2025.docx" target="new">March 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2024/FD%231+minutes+April+2025.docx" target="new">April 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/FD%231+minutes+May+2025+(1).docx" target="new">May 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2025/FD%231+minutes+June+2025.docx" target="new">June 2025</a><br/>
	</td>
	<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2025/FD%231+minutes+July+2025.docx" target="new">July 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2025/FD%231+minutes+August+2025.docx" target="new">August 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2025/FD%231+minutes+September+2025.docx" target="new">September 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2025/FD%231+minutes+October+2025.docx" target="new">October 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2025/FD%231+minutes+November+2025.docx" target="new">November 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/FD%231+minutes+December+2025.docx" target="new">December 2025</a><br/>





</td>
</tr>
<u><strong>2024 Meeting Minutes</strong></u>
</td>
</tr>
<tr>
<td valign="top">
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2024/minJan2024.docx" target="new">January 10, 2024</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2024/minJan2024_executive.docx" target="new">January 10, 2024 (Executive Session)</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2024/minFeb2024.docx" target="new">February 14, 2024</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2024/minMarch2024.docx" target="new">March 13, 2024</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2024/minApril2024.docx" target="new">April 10, 2024</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2024/minMay2024.docx" target="new">May 8, 2024</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2024/minJune2024.docx" target="new">June 12, 2024</a>
	</td>
	<td valign="top">
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2024/minJuly2024.pdf" target="new">July 10, 2024</a>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2024/minAug2024.docx" target="new">August 9, 2024</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2024/minSept2024.docx" target="new">September 13, 2024</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2024/minOct2024.docx" target="new">October 18, 2024</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2024/minNovember2024.docx" target="new">November 8, 2024</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2024/FD%231+minutes+December+2024.docx" target="new">December 13, 2024</a>
	</td>
	</tr>
	  </tbody>
	</table>
    <p>&nbsp;</p>
    <table width="auto" border="3">
<tbody><tr>
<td colspan="2" align="center">
<u><strong>2023 Meeting Minutes</strong></u>
</td>
</tr>
<tr>
<td valign="top">
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2023/minJanuary2023.docx">January 11, 2023</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2023/minFeb2023.docx">February 8, 2023</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2023/minMarch2023.docx" target="new">March 8, 2023</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2023/minApril2023.docx" target="new">April 12, 2023</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2023/minMay2023.docx" target="new">May 10, 2023</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2023/minJune2023.docx" target="new">June 14, 2023</a>
	</td>
	<td valign="top">
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2023/minJuly2023.docx" target="new">July 12, 2023</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2023/minAug2023.docx" target="new">August 9, 2023</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2023/minSept2023.docx" target="new">September 13, 2023</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2023/minOct2023.docx" target="new">October 18, 2023</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2023/minNov2023.docx" target="new">November 8, 2023</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2023/minDec2023.docx" target="new">December 13, 2023</a>
	</td>
	</tr>
		</tbody>
	</table>
	<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2" align="center">
<u><strong>2022 Meeting Minutes</strong></u>
</td>
</tr>
<tr>
<td valign="top">
  <p><a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2022/minJan2022.docx" target="new">January 12, 2022</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2022/minFeb2022.docx" target="new">February 9, 2022</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2022/minMarch2022.docx" target="new">March 9, 2022</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2022/minApril2022.docx" target="new">April 13, 2022</a><br/>
    <a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2022/minMay2022.docx" target="new">May 11, 2022</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2022/minJune2022.docx" target="new">June 8, 2022</a></p></td>
	<td valign="top">
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2022/minJuly2022.docx" target="new">July 13, 2022</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2022/minAug2022.docx" target="new">August 10, 2022</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2022/minSept2022.docx" target="new">September 14, 2022</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2022/minOct2022.docx" target="new">October 12, 2022</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2022/minNov2022.docx" target="new">November 9, 2022</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2022/minDec2022.docx" target="new">December 7, 2022</a>
	</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2" align="center">
<u><strong>2021 Meeting Minutes</strong></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2021/minJanuary2021.docx" target="new">January 13, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2021/minFeb2021.docx" target="new">February 10, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2021/minMarch2021.docx" target="new">March 10, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2021/minApril2021.docx" target="new">April 14, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2021/minMay2021.docx" target="new">May
12, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2021/minJune2021.docx" target="new">June 9, 2021</a>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2021/minJuly2021.docx" target="new">July 14, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2021/minAugust2021.docx" target="new">August 11, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2021/minSept2021.docx" target="new">September 8, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2021/minOct2021.docx" target="new">October 20, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2021/minNov2021.docx" target="new">November 10, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2021/minDec2021.docx" target="new">December 8, 2021</a>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2" align="center">
<u><strong>2020 Meeting Minutes</strong></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2020/minJanuary2020.docx" target="new">January 8, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2020/minFebruary2020.docx" target="new">February 12, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2020/minMarch2020.docx" target="new">March 11, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2020/minApril2020.docx" target="new">April 8, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2020/minMay2020.docx" target="new">May 13, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2020/minJune2020.docx" target="new">June 10, 2020</a>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2020/minJuly2020.docx" target="new">July 8, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2020/minAug2020.docx" target="new">August 12, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2020/minSept2020.docx" target="new">September 9, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2020/minOct2020 .docx" target="new">October 9, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2020/minNovember2020.docx" target="new">November 11, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2020/minSpecialNov113020.docx" target="new">November 30, 2020 (Special Meeting)</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2020/minDecember2020.docx" target="new">December 9, 2020</a>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2" align="center">
<u><strong>2019 Meeting Minutes</strong></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2019/minJan19.docx" target="new">January 9, 2019</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2019/minspecialJan011519.docx" target="new">January 15, 2019 (Special Meeting)</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2019/minFeb2019.docx" target="new">February 13, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2019/minMarch19.docx" target="new">March 13, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2019/minApril19.docx" target="new">April 10, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2019/minMay2019.docx" target="new">May 8, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2019/minJune2019.docx" target="new">June 12, 2019</a><br/>
	</td>
	<td valign="top">
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2019/minJuly2019.docx" target="new">July 10, 2019</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2019/minAugust2019.docx" target="new">August 14, 2019</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2019/minSept2019.docx" target="new">September 11, 2019</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2019/minOctober2019.docx" target="new">October 9, 2019</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2019/minutesNov2019.docx" target="new">November 13, 2019</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2019/minDec19.pdf">December 11, 2019</a>
</td>
</tr>
</tbody></table>
<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2" align="center">
<u><strong>2018 Meeting Minutes</strong></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2018/MinJAN18.doc" target="new">January 10, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2018/minfeb18.doc" target="new">February 14, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2018/MINmar18.doc" target="new">March 14, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2018/MiNapr18.doc" target="new">April 11, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2018/minMay18.pdf">May 09, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2018/minJune18.pdf">June 13, 2018</a><br/>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2018/minJuly18.pdf">July 11, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2018/minAug18.pdf">August 8, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2018/minSept18.docx" target="new">September 12, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2018/minOct18.docx" target="new">October 10, 2018</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2018/MinNov18.docx" target="new">November 14, 2018</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2018/minDec18.docx" target="new">December 12, 2018</a>
</td>
</tr>
</tbody></table>
<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2" align="center">
<u><strong>2017 Meeting Minutes</strong></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2017/MinJAN17.doc" target="new">January 11, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2017/MinFEB17.doc" target="new">February 8, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2017/MINmar17.doc" target="new">March 8, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2017/MinAPR17.doc" target="new">April 12, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2017/MinMAY17.doc" target="new">May 10, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2017/MinJUNE17.doc" target="new">June 14, 2017</a><br/>
</td>
<td valign="top">
<p><a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2017/MinJULY17.doc" target="new">July 12, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2017/MinAUG17.doc" target="new">August 9, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2017/MinSEPT17.doc" target="new">September 13, 2017</a><br/> 
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2017/MinOCT17.doc" target="new">October 11, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2017/MiNOV17.doc" target="new">November 8, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2017/MiNDec17.doc" target="new">December 13, 2017</a></p></td>
</tr>
</tbody></table>
<p></p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2" align="center">
<u><strong>2016 Meeting Minutes</strong></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2016/MinJAN16.doc" target="new">January 13, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2016/MinFEB16.doc" target="new">February 10, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2016/MINmar16.doc" target="new">March 9, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2016/MinAPR16.doc" target="new">April 13, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2016/MinMAY1116.doc" target="new">May 11, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2016/MinJUNE16.doc" target="new">June 8, 2016</a>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2016/MinJULY16.doc" target="new">July 13, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2016/Minaug16.doc" target="new">August 10, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2016/Minsept16.doc" target="new">September 14, 2016</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2016/MinOCT16.doc" target="new">October 12, 2016</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2016/MinNOV16.doc" target="new">November 9, 2016</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2016/MinDEC16.doc" target="new">December 14, 2016</a>
</td>
</tr>
</tbody></table>
<p></p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2" align="center">
<u><strong>2015 Meeting Minutes</strong></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2015/Minjan15.doc" target="new">January 21, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2015/MinFEB15.doc" target="new">February 18, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2015/MINmar15.doc" target="new">March 18, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2015/MinAPR15.doc" target="new">April 15, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2015/MinMay15.doc" target="new">May 20, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2015/MinJUNE15.doc" target="new">June 17, 2015</a>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2015/MinJULY15.doc" target="new">July 15, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2015/MinAUG15.doc" target="new">August 19, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2015/MinSEPT15.doc" target="new">September 16, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2015/MinOCT15.doc" target="new">October 21, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2015/MinNOV15.doc" target="new">November 18, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2015/MinDEC15.doc" target="new">December 16, 2015</a>
</td>
</tr>
</tbody></table>
<p></p>
<table width="auto" border="3">
  <tbody><tr>
<td colspan="2" align="center">
<u><strong>2014 Meeting Minutes</strong></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2014/MinJAN14.doc" target="new">January 15, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2014/MinFEB14.doc" target="new">February 19, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2014/MINmar14.doc" target="new">March 19, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2014/MinAPR14.doc" target="new">April 16, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2014/MinMAY14.doc" target="new">May 21, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2014/MinJUNE14.doc" target="new">June 18, 2014</a>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2014/MinJULY_14.doc" target="new">July 16, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2014/MinAUG14.doc" target="new">August 20, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2014/Minsept14.doc" target="new">September 17, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2014/MinOCT14.doc" target="new">October 15, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2014/MinNOV14.doc" target="new">November 19, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2014/MinDEC14.doc" target="new">December 17, 2014</a>
</td>
</tr>
</tbody></table>
<p></p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2" align="center">
<u><strong>2013 Meeting Minutes</strong></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2013/MinJAN13.doc" target="new">January 16, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2013/MinFED13.doc" target="new">February 20, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2013/MINmar13.doc" target="new">March 20, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2013/MinAPR13.doc" target="new">April 17, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2013/MinMay13.doc" target="new">May 15, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2013/Minjune13.doc" target="new">June 19, 2013</a><br/>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2013/Minjuly13.doc" target="new">July 17, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2013/MinAUG13.doc" target="new">August 21, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2013/MinSept13.doc" target="new">September 18, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2013/MinOCT13.doc" target="new">October 16, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2013/spmtgoct30.doc" target="new">October 30, 2013 (Special Meeting)</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2013/MinNOV13.doc" target="new">November 20, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2013/MinDEC13.doc" target="new">December 18, 2013</a>
</td>
</tr>
</tbody></table>
<p></p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2" align="center">
<u><strong>2012 Meeting Minutes</strong></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2012/MinJAN12.doc" target="new">January 18, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2012/MinFEB12.doc" target="new">February 15, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2012/MINmar12.doc" target="new">March 21, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2012/MinAPR12.doc" target="new">April 18, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2012/MinMAY12.doc" target="new">May 16, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2012/MinJUNE12.doc" target="new">June 20, 2012</a>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2012/MinJULY12.doc" target="new">July 18, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2012/MinAUG12.doc" target="new">August 15, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2012/MinSEPT12.doc" target="new">September 19, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2012/MinOCT12.doc" target="new">October 17, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2012/MinNOV12.doc" target="new">November 21, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2012/MinDEC12.doc" target="new">December 19, 2012</a>
</td>
</tr>
</tbody></table>
<p></p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2" align="center">
<u><strong>2011 Meeting Minutes</strong></u>
</td>
</tr>
<tr>
<td valign="top" align="left">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2011/MinJAN11.doc" target="new">January 19, 2011</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2011/MinFEB11.doc" target="new">February 16, 2011</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2011/MINmar11.doc" target="new">March 16, 2011</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2011/Minapr11.doc" target="new">April 20, 2011</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2011/MinMAY4SPMTG.doc" target="new">May 4, 2011 (Special Meeting)</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2011/MinMAY11.doc" target="new">May 11, 2011</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2011/minjune11.doc" target="new">June 15, 2011</a>
</td>
<td valign="top" align="left">
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2011/Minjuly11.doc" target="new">July 11, 2011</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2011/MinAUG11.doc" target="new">August 17, 2011</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2011/MinSEPT11.doc" target="new">September 21, 2011</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2011/MinOCT11.doc" target="new">October 19, 2011</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2011/MinNov11.doc" target="new">November 16, 2011</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Minutes/2011/MinDEC11.doc" target="new">December 14, 2011</a>
</td>
</tr>
</tbody></table>

</center>
        </>
    )
}